// extracted by mini-css-extract-plugin
export default {"icon":"icon__Fh7kpB7x","subText":"subText__vyY7pDGr","linkIcon":"linkIcon__dAwQ2MC0"};